export enum RoutingSyncMessageTypes {
    ParentToChild = "urlChange",
    ChildToParent = "routeChange",
    HistoryType = "routingSyncHistory",
}

export interface IRoutingSyncMessageType extends MessageEvent {
    url: string;
    type: RoutingSyncMessageTypes;
}
export const sendRoutingSyncToParent = (parentWindow: Window, parentOrigin: string, newUrl: string) => {
    parentWindow.postMessage(
        {
            message: RoutingSyncMessageTypes.ChildToParent,
            url: newUrl.replace("%25", "%").replace("%25", "%"),
        },
        parentOrigin,
    );
};

export const isRoutingSyncEventFromParent = (parentOrigin: string, event: MessageEvent<unknown>): event is IRoutingSyncMessageType => {
    return event.origin === parentOrigin && (event as IRoutingSyncMessageType).data?.type === RoutingSyncMessageTypes.ParentToChild;
};

export const sendRoutingSyncToChild = (childWindow: Window | null, childOrigin: string, newUrl: string) => {
    childWindow?.postMessage(
        {
            message: RoutingSyncMessageTypes.ParentToChild,
            url: newUrl,
        },
        childOrigin,
    );
};

export const isRoutingSyncEventFromChild = (childOrigin: string, event: MessageEvent) => {
    return event.origin === childOrigin && event.data && event.data.message === RoutingSyncMessageTypes.ChildToParent;
};

/* istanbul ignore next */
const safeConcatUrl = (p1: string, p2: string) => {
    if (p1.endsWith("/")) {
        return p2.startsWith("/") ? `${p1}${p2.substr(1)}` : `${p1}${p2}`;
    }

    return p2.startsWith("/") ? `${p1}${p2}` : `${p1}/${p2}`;
};

export const initParentOfChildRoutingSync = (
    parentWindow: Window,
    iframeElement: any,
    childUrl: URL,
    parentPathPrefix = "",
    childInitialPath = "",
): void => {
    const getParentPath = () => `${parentWindow.location.pathname}${parentWindow.location.search}${parentWindow.location.hash}`;
    const getChildRoutingFromParentPath = () => getParentPath().replace(parentPathPrefix, "") || childInitialPath;

    iframeElement.setAttribute("src", safeConcatUrl(childUrl.href, getChildRoutingFromParentPath()));

    parentWindow.addEventListener("popstate", (event) => {
        if (event.state?.type === RoutingSyncMessageTypes.HistoryType) {
            sendRoutingSyncToChild(iframeElement.contentWindow, childUrl.origin, event.state.url.replace(parentPathPrefix, ""));
        } else if (!event.state) {
            sendRoutingSyncToChild(iframeElement.contentWindow, childUrl.origin, getChildRoutingFromParentPath());
        }
    });

    parentWindow.addEventListener("message", (event) => {
        if (event.origin !== childUrl.origin) {
            return;
        }

        if (isRoutingSyncEventFromChild(childUrl.origin, event)) {
            if ((parentWindow.history.state?.url || "").endsWith(event.data.url)) {
                return;
            }
            parentWindow.history.replaceState(
                {
                    type: RoutingSyncMessageTypes.HistoryType,
                    url: safeConcatUrl(parentPathPrefix, event.data.url),
                },
                safeConcatUrl(parentPathPrefix, event.data.url),
                safeConcatUrl(parentPathPrefix, event.data.url),
            );
        }
    });
};
